import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Inbox, Trash2 } from "lucide-react";
import { toast } from "sonner";

const AdminContacts = () => {
  const [items, setItems] = useState([]);

  const load = () => api.get("/contact").then((r) => setItems(r.data)).catch(() => {});
  useEffect(() => { load(); }, []);

  const remove = async (id) => {
    if (!window.confirm("Delete this message?")) return;
    await api.delete(`/contact/${id}`);
    toast.success("Deleted");
    load();
  };

  return (
    <div data-testid="admin-contacts-page">
      <h1 className="font-heading text-3xl font-semibold tracking-tight">Feedback Inbox</h1>
      <p className="text-muted-foreground mt-1 mb-8">Messages submitted from the Contact page.</p>

      {items.length === 0 ? (
        <div className="border border-dashed border-border rounded-xl p-12 text-center text-muted-foreground">
          <Inbox className="mx-auto mb-2" />
          No feedback messages yet.
        </div>
      ) : (
        <div className="space-y-4">
          {items.map((c) => (
            <Card key={c.id} className="border-border" data-testid={`contact-row-${c.id}`}>
              <CardContent className="p-6">
                <div className="flex justify-between gap-4">
                  <div>
                    <div className="font-heading text-lg font-semibold">{c.subject || "(no subject)"}</div>
                    <div className="text-sm text-muted-foreground mt-0.5">
                      From <span className="font-medium text-foreground/90">{c.name}</span> · <a className="link-underline" href={`mailto:${c.email}`}>{c.email}</a>
                    </div>
                  </div>
                  <Button variant="ghost" size="icon" onClick={() => remove(c.id)} aria-label="Delete" data-testid={`contact-delete-${c.id}`}>
                    <Trash2 size={15} />
                  </Button>
                </div>
                <p className="mt-4 whitespace-pre-wrap text-foreground/85 leading-relaxed">{c.message}</p>
                <div className="text-xs text-muted-foreground mt-3">{new Date(c.created_at).toLocaleString()}</div>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
};

export default AdminContacts;
